import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

export const CenteredCircularProgress = ({ color = 'secondary' }) => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress color={color} />
    </Box>
);